import React from "react";

export default function Navbar() {
  return (
    <nav className="bg-slate-100 shadow-md">
      <div className="max-w-7xl mx-auto px-5 lg:px-0 flex justify-between py-3 items-center">
        <h1>Dev Blogs</h1>
      </div>
    </nav>
  );
}
